"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsManualAddressMode = exports.getIsAddressChanged = exports.getIsAddressVerified = exports.getOriginalAddress = exports.getVerifiedAddress = exports.getShippingAddress = exports.getIsValidated = exports.getErrors = exports.getIsPending = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var pathToShippingState = function pathToShippingState(state) {
  return state.createGift.shipping;
};

var getIsPending = (0, _ramda.pipe)(pathToShippingState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getIsPending = getIsPending;
var getErrors = (0, _ramda.pipe)(pathToShippingState, function (state) {
  return state.errors;
});
exports.getErrors = getErrors;
var getIsValidated = (0, _ramda.pipe)(pathToShippingState, function (state) {
  return state.isValidated;
});
exports.getIsValidated = getIsValidated;
var getShippingAddress = (0, _ramda.pipe)(pathToShippingState, function (state) {
  return state.address;
});
exports.getShippingAddress = getShippingAddress;
var getVerifiedAddress = (0, _ramda.pipe)(pathToShippingState, function (state) {
  return state.verifiedAddress;
});
exports.getVerifiedAddress = getVerifiedAddress;
var getOriginalAddress = (0, _ramda.pipe)(pathToShippingState, function (state) {
  var _state$address;

  return (_state$address = state.address) === null || _state$address === void 0 ? void 0 : _state$address.address;
});
exports.getOriginalAddress = getOriginalAddress;
var getIsAddressVerified = (0, _ramda.pipe)(pathToShippingState, function (state) {
  return state.isAddressVerified;
});
exports.getIsAddressVerified = getIsAddressVerified;
var getIsAddressChanged = (0, _ramda.pipe)(pathToShippingState, function (state) {
  return state.isAddressChanged;
});
exports.getIsAddressChanged = getIsAddressChanged;
var getIsManualAddressMode = (0, _ramda.pipe)(pathToShippingState, function (state) {
  return state.isManualAddressMode;
});
exports.getIsManualAddressMode = getIsManualAddressMode;